module.exports = __webpack_public_path__ + "img/jewelry@2x.d7459b7.webp";